/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_File_TypesInputs */

const en_story_file_types = /** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG · PNG · WebP · MP4 · WebM — max 50MB`)
};

const es_story_file_types = /** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG · PNG · WebP · MP4 · WebM — máx 50MB`)
};

const fr_story_file_types = /** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG · PNG · WebP · MP4 · WebM — max 50 Mo`)
};

const de_story_file_types = /** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG · PNG · WebP · MP4 · WebM — max. 50MB`)
};

const id_story_file_types = /** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG · PNG · WebP · MP4 · WebM — maks 50MB`)
};

/** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */
const ja_story_file_types = en_story_file_types;

/** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */
const zh_story_file_types = en_story_file_types;

/** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */
const ar_story_file_types = en_story_file_types;

/** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */
const it_story_file_types = en_story_file_types;

/** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */
const ru_story_file_types = en_story_file_types;

/** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */
const pt_story_file_types = en_story_file_types;

/** @type {(inputs: Story_File_TypesInputs) => LocalizedString} */
const ko_story_file_types = en_story_file_types;

/**
* | output |
* | --- |
* | "JPEG · PNG · WebP · MP4 · WebM — max 50MB" |
*
* @param {Story_File_TypesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_file_types = /** @type {((inputs?: Story_File_TypesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_File_TypesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_file_types(inputs)
	if (locale === "es") return es_story_file_types(inputs)
	if (locale === "fr") return fr_story_file_types(inputs)
	if (locale === "de") return de_story_file_types(inputs)
	if (locale === "ja") return ja_story_file_types(inputs)
	if (locale === "zh") return zh_story_file_types(inputs)
	if (locale === "ar") return ar_story_file_types(inputs)
	if (locale === "id") return id_story_file_types(inputs)
	if (locale === "it") return it_story_file_types(inputs)
	if (locale === "ru") return ru_story_file_types(inputs)
	if (locale === "pt") return pt_story_file_types(inputs)
	return ko_story_file_types(inputs)
});